import {createAction} from 'redux-actions'
import {Feature} from '../../features/constants'
import * as FeaturesActions from '../../features/actions'
import * as EntitiesActions from '../../entities/actions'
import {addDefaultUserGroup} from '../../util/groupUtils'

export default function({
    actionTypes: {
        ASSIGNED_USERS_SET,
        ASSIGNED_MANAGERS_SET,
        CAN_MODIFY_ANY_USER_SET,
        CAN_MODIFY_ANY_MANAGER_SET,
    }
}) {

    const setAssignedUsers = createAction(ASSIGNED_USERS_SET)
    const setCanModifyAnyUser = createAction(CAN_MODIFY_ANY_USER_SET)
    const setAssignedManagers = createAction(ASSIGNED_MANAGERS_SET)
    const setCanModifyAnyManager = createAction(CAN_MODIFY_ANY_MANAGER_SET)

    const setAssignedUsersData = ({
        users,
        userGroups,
        timeZoneGroups,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        canModifyAny
    }) => (dispatch) => {
        dispatch(loadGroupsInfo({
            userGroups,
            timeZoneGroups,
            userGroupsEnabled,
            timeZoneGroupsEnabled,
        }))
        dispatch(setCanModifyAnyUser(canModifyAny))
        dispatch(setAssignedUsers(users))
    }

    const setAssignedManagersData = ({
        users,
        userGroups,
        timeZoneGroups,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
        canModifyAny
    }) => (dispatch) => {
        dispatch(loadGroupsInfo({
            userGroups,
            timeZoneGroups,
            userGroupsEnabled,
            timeZoneGroupsEnabled,
        }))
        dispatch(setCanModifyAnyManager(canModifyAny))
        dispatch(setAssignedManagers(users))
    }

    const loadGroupsInfo = ({
        userGroups,
        timeZoneGroups,
        userGroupsEnabled,
        timeZoneGroupsEnabled,
    }) => (dispatch) => {
        const userGroupsWithDefault = (userGroups) ? addDefaultUserGroup(userGroups) : userGroups
        dispatch(EntitiesActions.setUserGroups(userGroupsWithDefault))
        dispatch(EntitiesActions.setTimeZoneGroups(timeZoneGroups))
        dispatch(FeaturesActions.updateFeatures({[Feature.UGR]: userGroupsEnabled}))
        dispatch(FeaturesActions.updateFeatures({[Feature.TZG]: timeZoneGroupsEnabled}))
    }

    return {
        setAssignedUsersData,
        setAssignedManagersData,
        setAssignedUsers,
        setAssignedManagers,
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/usersAssignedToHierarchy/actionsGenerator.js